import React, { useRef } from 'react'
import { Route, Redirect, Switch, useRouteMatch, useHistory } from 'react-router-dom'
import { withTranslation } from 'react-i18next'
import PrivateRoute from './PrivateRoute'
import IdleTimer from 'react-idle-timer'
import PageNotFound from 'shared/components/PageNotFound.jsx'
import Layout from 'containers/Layout/topbar/index.jsx'
import Footer from 'containers/Layout/footer/footer.jsx'
import ReceiveConfirmation from '../ReceiveConfirmation'
import Confirmation from '../Confirmation'
import PrivacyNotice from '../PrivacyNotice'
import ScreeningQuestion from '../ScreeningQuestion'
import ScreeningQuestionYes from '../ScreeningQuestionYes'
import DebtInformation from '../DebtInformation'
import DebtInformationList from '../DebtInformationList'
import ContactInformation from '../ContactInformation'
import MailingAddress from '../MailingAddress'
import ReviewSummary from '../ReviewSummary'
import VehicleTaxDebt from '../VehicleTaxDebt'
import UpdateMailingAddressQuestion from '../UpdateMailingAddressQuestion'

const PayADebtServicesRoutes = ({ t, i18n }) => {
  const match = useRouteMatch()
  const history = useHistory()
  const idleMinutes = process.env.REACT_APP_IDLE_TIMEOUNT_MINUTES

  const idleEl = useRef(null)

  const onIdle = () => {
    // history.push(`${match.path}${t('routes.privacy_notice')}`)
    history.push(`${match.path}${t('routes.screening_question')}`)
  }

  return (
    <React.Fragment>
      <IdleTimer ref={idleEl} crossTab element={document} onIdle={onIdle} debounce={250} timeout={1000 * 60 * parseFloat(idleMinutes)} />
      <Layout />
      <Switch>
        <Route path={`${match.path}${t('routes.not_found')}`} component={PageNotFound} />
        <PrivateRoute path={`${match.path}${t('routes.receive_confirmation')}/:transId/:transOwner`} component={ReceiveConfirmation} />
        <Route path={`${match.path}${t('routes.confirmation')}`} component={Confirmation} />
        <PrivateRoute path={`${match.path}${t('routes.vehicle_tax_debt')}`} component={VehicleTaxDebt} />
        <PrivateRoute path={`${match.path}${t('routes.screening_question_yes')}`} component={ScreeningQuestionYes} />
        <PrivateRoute path={`${match.path}${t('routes.debt_info')}`} component={DebtInformation} />
        <PrivateRoute path={`${match.path}${t('routes.debt_info_list')}`} component={DebtInformationList} />
        <PrivateRoute path={`${match.path}${t('routes.contact_information')}`} component={ContactInformation} />

        <PrivateRoute path={`${match.path}${t('routes.update_mailing_address_question')}`} component={UpdateMailingAddressQuestion} />
        <PrivateRoute path={`${match.path}${t('routes.mailing_address')}`} component={MailingAddress} />

        <PrivateRoute path={`${match.path}${t('routes.review_summary')}`} component={ReviewSummary} />
        {/* <Route path={`${match.path}${t('routes.privacy_notice')}`} component={PrivacyNotice} /> */}
        <Route path={`${match.path}${t('routes.screening_question')}`} component={ScreeningQuestion} />
        <Redirect from={`/${i18n.language}/*`} to={`${match.path}${t('routes.not_found')}`} />
        {/* <Redirect exact from={`${match.path}`} to={`${match.path}${t('routes.privacy_notice')}`} /> */}
        <Redirect exact from={`${match.path}`} to={`${match.path}${t('routes.screening_question')}`} />
      </Switch>
      <Footer />
    </React.Fragment>
  )
}

export default withTranslation('common')(PayADebtServicesRoutes)
